import _ from 'lodash';
import React from 'react';

var blockOuterScroll = function blockOuterScroll(e) {
  var contentNode = e.currentTarget;

  if (window.document.activeElement === contentNode) {
    var totalHeight = e.currentTarget.scrollHeight;
    var maxScroll = totalHeight - e.currentTarget.offsetHeight;
    var delta = e.deltaY % 3 ? e.deltaY : e.deltaY * 10;

    if (contentNode.scrollTop + delta <= 0) {
      contentNode.scrollTop = 0;

      if (!e.defaultPrevented) {
        e.preventDefault();
      }
    } else if (contentNode.scrollTop + delta >= maxScroll) {
      contentNode.scrollTop = maxScroll;

      if (!e.defaultPrevented) {
        e.preventDefault();
      }
    }

    e.stopPropagation();
  }
};

var withBlockOuterScroll = function withBlockOuterScroll(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(Component, _.defaults({
      blockOuterScroll: blockOuterScroll
    }, props));
  };
};

export default withBlockOuterScroll;